import { useState } from "react";
import { capitalFirst } from "../utils/stringUtils";
import { Filter } from "./Filter";

function genNumbers(from, to, appendix="", step=1) {
    const ret = [{value: undefined, title: ""}];
    for(var i =from; i< to; i += step) {
        ret.push({value: i, title: i + "" + appendix} )
    }
    return ret;
}

const hairColors = [undefined, "platinum", "blonde", "black", "brown", "red", 'pink', 'green', 'blue', 'purple', "gray"];
const races = [undefined, "Northern", "Caucasian", "Latino", "Black", "Arab", "Indian", "Asian"];


function Pagination({botCount, page, pageSize, filterOptions, setPage}) {
    const items = [];
    for(var i = 0; i < (botCount/pageSize) && i < 10; i++) {
      function man(i) {
        items.push(<div key={i} className={"font-bold " + (page !== i ? "text-pink cursor-pointer" : "")}  onClick={async () => {
          //console.log("setting page to", i);
          await setPage(i);
        }}>{i + 1}</div>)
      };
      man(i);
    }
    return (
      <div className="mt-20 m-auto w-1/2 flex flex-row justify-center space-x-2 md:space-x-6">
          <div>Page</div>
          {items}
      </div>
    )
  }

  export const filterConfigs = [
    {
        name: "properties.bot_gender", 
        title: "Gender",
        values: [{value: undefined, title: " "}, {value: "female", title: "female"},{value: "male", title: "male"}],
        noOperator: true
    },
    {
        name: "properties.bot_age", 
        title: "Age",
        //values: genNumbers(18, 50),
        noOperator: true,
        values: [
            {value: undefined, title: " "}, 
            {value: {$lt: 20}, title: "teen"}, 
            {value: {$gte: 20, $lte: 27}, title: "gen-z"}, 
            {value: {$gt: 28, $lte: 43}, title: "millenial"}, 
            {value: {$gt: 43, $lte: 59}, title: "gen-x"}, 
            {value: {$gt: 59}, title: "boomer"}, 
        ],
        jsonValue: true
    },
    {
        name: "properties.bot_bodyheight", 
        title: "Height",
        noOperator: true,
        values: [
            {value: undefined, title: " "}, 
            {value: {$lt: 154}, title: "midget"}, 
            {value: {$gte: 154, $lte: 161}, title: "small"}, 
            {value: {$gt: 161, $lte: 170}, title: "normal"}, 
            {value: {$gt: 170, $lte: 180}, title: "tall"}, 
            {value: {$gt: 180, $lte: 190}, title: "very tall"}, 
            {value: {$gt: 190}, title: "giant"}, 
        ],
        jsonValue: true
        //values: genNumbers(150, 200, "cm", 2)
    },
    {
        name: "properties.bot_bodybmi", 
        title: "Shape",
        noOperator: true,
        jsonValue: true, 
        values: [
            {value: undefined, title: " "}, 
            {value: {$lte: 19}, title: "very skinny"}, 
            {value: {$gt: 19, $lte: 21}, title: "skinny"}, 
            {value: {$gt: 21, $lte: 24}, title: "normal"}, 
            {value: {$gt: 24, $lte: 27}, title: "heavy"}, 
            {value: {$gt: 27}, title: "obese"}]
    },
    {
        name: "properties.bot_ethnicity", 
        title: "Race",
        values: races.map((col) => { return {value: col, title: capitalFirst(col)}}),
        noOperator: true
    },
    {
        name: "properties.bot_haircolor", 
        title: "Hairs",
        values: hairColors.map((col) => { return {value: col, title: capitalFirst(col)}}),
        noOperator: true
    }
];

export function BotFilters({onQueryChange, query}) {

    const filters = query;
    //console.log("building botFilters with query", query);
    //const [filters, setFilters] = useState(query);
    

    function filterChange({name, value, operator, noOperator, jsonValue}) {
        //console.log("filterChange", value);
        const newFilters = value ? {...filters, [name]: {value, operator, noOperator, jsonValue}} : {...filters };
        if(!value) {
            delete newFilters[name];
            delete query[name];
        }
        //setFilters(newFilters);
        constructQuery(newFilters);
    }

    function constructQuery(filters) {
        const newQuery = Object.keys(filters).reduce((ret, filterName) => {
            //console.log("filters[filterName].value", filters[filterName].value);
            return filters[filterName].value 
                ? {     
                    ...ret, 
                    [filterName]: filters[filterName].noOperator 
                        ? filters[filterName].jsonValue ? JSON.parse(filters[filterName].value) : filters[filterName].value 
                        : {[filters[filterName].operator]: parseInt(filters[filterName].value)}
                } 
                : ret;
        }, {})
        console.log("newQuery", newQuery);
        onQueryChange({...query, ...newQuery});
    }

    return <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
        {filterConfigs.map((filter) => {
            //console.log("query[filter.name]", query, filter.name, query[filter.name]? Object.values(query[filter.name])[0] : "", filters[filter.name] ? filters[filter.name].value : (query[filter.name] ? (filter.noOperator ? query[filter.name] : Object.values(query[filter.name])[0]) : undefined));
            const val = (
                query[filter.name] 
                    ? (filter.noOperator 
                        ? (filter.jsonValue ? JSON.stringify(query[filter.name]) : query[filter.name])
                        : Object.values(query[filter.name])[0]) 
                    : (filters[filter.name] ? filters[filter.name].value : undefined));
            //console.log("val is", val);
            return <div key={filter.name}>
                <Filter 
                    value={val}
                    operator={(query[filter.name] ? ((filter.noOperator ? undefined : Object.keys(query[filter.name])[0])) : (filters[filter.name] ? filters[filter.name].operator : undefined))}
                    name={filter.name}
                    title={filter.title}
                    values={filter.values}
                    onChange={filterChange}
                    noOperator={filter.noOperator}
                    jsonValue={filter.jsonValue}
                />
            </div>
        })}
    </div>
}

